// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:31Z                      #

// ##############################################################


/**
 * Vyjmenované hodnoty pro sign_Timestamp_Level.
 */
enum EnumSignTimestampLevel {
    QUALIFIED = 'QUALIFIED', 
    GUARANTEED = 'GUARANTEED', 
    NONE = 'NONE'
};
export default EnumSignTimestampLevel;

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [EnumSignTimestampLevel.QUALIFIED]: {caption: ''},
    [EnumSignTimestampLevel.GUARANTEED]: {caption: ''},
    [EnumSignTimestampLevel.NONE]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}
